import "./ResultModal.css";
import { ShareToX } from "./ShareToX";

type Props = {
  open: boolean;
  time: number;
  moves: number;
  onClose: () => void;
  onPlayAgain: () => void;
};

export function ResultModal({ open, time, moves, onClose, onPlayAgain }: Props) {
  if (!open) return null;
  return (
    <div className="modal-backdrop">
      <div className="modal modal-congrats">
        <div className="fireworks">
          <div className="firework firework-1" />
          <div className="firework firework-2" />
          <div className="firework firework-3" />
        </div>

        <h2>Congratulations! 🎉</h2>
        <p className="highlight-time">
          You finished in <span>{Math.floor(time / 60)}:{(time % 60).toFixed(0).padStart(2, '0')}</span>
        </p>
        <p>Moves: {moves}</p>

        <div className="modal-actions">
          <button className="btn secondary" onClick={onClose}>
            Close
          </button>
          <button className="btn" onClick={onPlayAgain}>
            Play Again
          </button>
          <ShareToX />
        </div>
      </div>
    </div>
  );
}